declare const grecaptcha: {
  enterprise: {
    execute: (siteKey: string, options: { action: string }) => Promise<string>;
  };
};

// The reCAPTCHA script loads with async+defer, so it may not have set up the
// grecaptcha global by the time mounted() fires. Poll briefly before giving up.
function waitForGrecaptcha(timeoutMs = 5000): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
      return resolve();
    }
    const deadline = Date.now() + timeoutMs;
    const poll = setInterval(() => {
      if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
        clearInterval(poll);
        resolve();
      } else if (Date.now() > deadline) {
        clearInterval(poll);
        reject(new Error('reCAPTCHA script not loaded'));
      }
    }, 100);
  });
}

export default function useRecaptcha() {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string;

  const getToken = async (action: string): Promise<string> => {
    await waitForGrecaptcha();
    return new Promise((resolve, reject) => {
      grecaptcha.enterprise.ready(async () => {
        try {
          resolve(await grecaptcha.enterprise.execute(siteKey, { action }));
        } catch (err) {
          reject(err);
        }
      });
    });
  };

  return { getToken };
}
